import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getStudentAddress = () => httpClient.get(apis.GET_STUDENT_ADDRESS, { ignore: true });

export const makeNewAddress = (payload) =>
  httpClient.post(apis.MAKE_NEW_ADDRESS, payload, { ignore: true });

export const deleteAddress = (payload) =>
  httpClient.post(apis.DELETE_ADDRESS, payload, { ignore: true });
